/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import useOnlineStatus from '@rehooks/online-status';
import {
  useFeatureFlagDispatch,
  useAuthState,
  useFeatureFlagState,
} from 'context';
import gql from 'graphql-tag';
import { Modal } from 'components';
import { OfflineModal } from '../Modal';
import { getFlag, flags, initTrackingContext, getApolloClient, apolloPersistor } from 'services';

const FeatureFlagsQuery = gql`
  query getFeatureFlags {
    featureFlags {
      name
      active
    }
  }
`;

export const Interstitial: React.FC = (props) => {
  const [currentOnlineStatus, setCurrentOnlineStatus] = useState(true);
  const onlineStatus = useOnlineStatus();

  useEffect(() => {
    setCurrentOnlineStatus(onlineStatus);
  }, []);

  useEffect(() => {
    if (onlineStatus != currentOnlineStatus) {
      if (currentOnlineStatus === false && onlineStatus === true) {
        window.location.reload();
      } else {
        setCurrentOnlineStatus(onlineStatus);
      }
    }
  }, [onlineStatus]);

  return (
    <>
      {currentOnlineStatus && <>{props.children}</>}
      <Modal isOpen={!currentOnlineStatus} onRequestClose={null}>
        <OfflineModal />
      </Modal>
      <OnLoadTracker />
    </>
  );
};

export const OnLoadTracker: React.FC = (props) => {
  const featureFlagDispatch = useFeatureFlagDispatch();
  const { isAuthenticated } = useAuthState();
  const { groupsFeatureFlag } = useFeatureFlagState();
  const client = useApolloClient();

  async function getFlagsFromServer() {
    client
      .query({
        query: FeatureFlagsQuery,
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        const groupsFlag = res.data.featureFlags.find((flag: any) => {
          return flag.name.includes('groups');
        });
        if (groupsFlag.active != groupsFeatureFlag  ) {
          apolloPersistor.pause();
          getApolloClient().then((apollo) => {
            apollo.clearStore();
            apolloPersistor.purge().then(() => {
              featureFlagDispatch({ type: 'TOGGLE_GROUPS', payload: groupsFlag.active });
            });
          });
        }
      });
  }

  useEffect(() => {
    if (getFlag(flags.FeatureFlagsFromServer)) {
      getFlagsFromServer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      initTrackingContext();
    }
  }, [isAuthenticated]);

  return null;
};
